import { getEventTypeGroupFromJson } from '../../events/data_types'

import dataTypes from './data_types_config.json'

export const rugbyLeagueEventTypes = getEventTypeGroupFromJson(
  dataTypes,
  'Rugby League'
)
